import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

const SuperUserDashboard = () => {
    const { api } = useAuth();
    const [societies, setSocieties] = useState([]);

    useEffect(() => {
        api.get('/api/superuser-dashboard/').then(res => setSocieties(res.data));
    }, [api]);

    return (
        <div className="p-8">
            <h1 className="text-3xl font-bold">Super User Dashboard</h1>
            <h2 className="text-xl mt-6">All Societies</h2>
            <div className="mt-4 bg-white shadow rounded-lg">
                <ul>
                    {societies.map(society => (
                        <li key={society.id} className="p-4 border-b flex justify-between">
                            <span>{society.name} ({society.schema_name})</span>
                            <button className="text-red-500 hover:text-red-700">Delete</button>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default SuperUserDashboard;